/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'unlock': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M196.923 356.43v7.878-7.877zm630.154 96.493h-512V360.37c0-104.369 78.77-196.923 183.138-202.83 96.493-5.908 177.231 55.138 202.831 141.784 1.97 7.877 9.846 15.754 19.692 15.754h80.739c11.815 0 21.661-11.815 19.692-23.63-31.507-149.662-165.415-259.94-324.923-252.062-167.384 7.877-295.384 151.63-299.323 317.046v96.492c-43.323 0-78.77 35.446-78.77 78.77v374.153c0 43.323 35.447 78.77 78.77 78.77h630.154c43.323 0 78.77-35.447 78.77-78.77V531.692c0-43.323-35.447-78.769-78.77-78.769zM602.585 840.862c3.938 11.815-5.908 25.6-19.693 25.6H439.138c-13.784 0-23.63-11.816-19.692-25.6l35.446-118.154c-29.538-19.693-47.261-55.139-39.384-94.523 7.877-37.416 37.415-66.954 76.8-74.831 63.015-11.816 118.154 33.477 118.154 92.554 0 31.507-15.754 61.046-41.354 76.8l33.477 118.154z"/>'
  }
})
